<script>
import { OBJLoader } from "three/examples/jsm/loaders/OBJLoader";
import { MTLLoader } from "three/examples/jsm/loaders/MTLLoader";
//import { DDSLoader } from "three/examples/jsm/loaders/DDSLoader";
//import { LoadingManager } from "three/src/loaders/LoadingManager";
import { toIndexed } from "./AugmentableUtils";
import mixin from "./AugmentableMixin.vue";

import {
  PMREMGenerator,
  UnsignedByteType,
  // Mesh,
  // SimplifyModifier,
  // Geometry,
  // DoubleSide,
} from "three";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";

// TODO: Better way to handle texture formats
// const manager = new LoadingManager(); // 0.122+ new api
// manager.addHandler(/\.dds$/i, new DDSLoader());
export default {
  name: "AugmentableObj",
  mixins: [mixin],
  props: {
    lights: {
      type: Array,
      default() {
        return [
          {
            type: "HemisphereLight",
            position: { x: 0, y: 1, z: 0 },
            skyColor: 0xaaaaff,
            groundColor: 0x806060,
            intensity: 0.2,
          },
          {
            type: "DirectionalLight",
            position: { x: 1, y: 1, z: 1 },
            color: 0xffffff,
            intensity: 0.8,
          },
        ];
      },
    },
    smoothing: {
      type: Boolean,
      default: false,
    },
    mtlPath: {
      type: String,
    },
    mtl: {
      type: String,
    },
  },
  data() {
    const objLoader = new OBJLoader(this.manager).setCrossOrigin("anonymous");
    const mtlLoader = new MTLLoader(this.manager).setCrossOrigin("anonymous");
    mtlLoader.setCrossOrigin(this.crossOrigin);
    objLoader.setCrossOrigin(this.crossOrigin);
    mtlLoader.setRequestHeader(this.requestHeader);
    objLoader.setRequestHeader(this.requestHeader);
    return {
      loader: objLoader,
      mtlLoader,
    };
  },
  watch: {
    mtl() {
      this.load();
    },
  },
  methods: {
    process(object) {
      if (this.smoothing) {
        object.traverse((child) => {
          if (child.geometry) {
            child.geometry = toIndexed(child.geometry);
            child.geometry.computeVertexNormals();
          }
        });
      }
    },
    load() {
      if (!this.src) return;
      if (this.object) {
        this.wrapper.remove(this.object);
      }

      const onLoad = (object) => {
        if (this.process) {
          // object.traverse(function (child) {
          //   if (child instanceof Mesh) {
          //     console.log("eewewewewe");
          //     console.log(child);
          //     child.material.side = DoubleSide;
          //     let MeshGeometry = new Geometry().fromBufferGeometry(
          //       child.geometry
          //     );
          //     MeshGeometry.computeFaceNormals();
          //     MeshGeometry.mergeVertices();
          //     MeshGeometry.computeVertexNormals();

          //     var modifier = new SimplifyModifier();
          //     var simplified = modifier.modify(
          //       MeshGeometry,
          //       (MeshGeometry.vertices.length * 0.85) | 0
          //     );
          //     simplified.computeFaceNormals();
          //     simplified.computeVertexNormals();

          //     let material1 = child.material.clone();
          //     let mesh = new Mesh(simplified, material1);
          //     this.scene.add(mesh);
          //   }
          // });
          this.process(object);
        }
        this.addObject(object);
        this.$emit("on-load");
      };
      const onProgress = (xhr) => {
        this.$emit("on-progress", xhr);
      };
      const onError = (err) => {
        this.$emit("on-error", err);
      };
      if (this.mtl) {
        let { mtlPath } = this;
        let mtlSrc = this.mtl;
        console.log("ggg");
        console.log(mtlPath);
        console.log(mtlSrc);
        if (!this.mtlPath) {
          const result = /^(.*\/)([^/]*)$/.exec(this.mtl);
          console.log(result);
          if (result) {
            mtlPath = result[1];
            mtlSrc = result[2];
          }
        }
        if (mtlPath) {
          this.mtlLoader.setPath(mtlPath);
        }
        this.mtlLoader.load(
          mtlSrc,
          (materials) => {
            materials.preload();
            this.loader
              .setMaterials(materials)
              .load(this.src, onLoad, onProgress, onError);
          },
          () => {},
          onError
        );
      } else {
        this.loader.load(this.src, onLoad, onProgress, onError);
      }
    },

    changeEnvironmentImage() {
      let { environmentImage } = this;

      if (!this.src) return;

      let { scene } = this;

      const pmremGenerator = new PMREMGenerator(this.renderer);
      pmremGenerator.compileEquirectangularShader();
      new RGBELoader()
        .setDataType(UnsignedByteType)
        .load(environmentImage, function (texture) {
          var envMap = pmremGenerator.fromEquirectangular(texture).texture;

          scene.environment = envMap;

          texture.dispose();
          pmremGenerator.dispose();
        });
    },
    changeSkyboxImage() {
      let { skyboxImage } = this;

      if (!this.src) return;

      let { scene } = this;
      if (skyboxImage) {
        const pmremGenerator = new PMREMGenerator(this.renderer);
        pmremGenerator.compileEquirectangularShader();
        new RGBELoader()
          .setDataType(UnsignedByteType)
          .load(skyboxImage, function (texture) {
            var envMap = pmremGenerator.fromEquirectangular(texture).texture;

            scene.background = envMap;

            texture.dispose();
            pmremGenerator.dispose();
          });
      } else {
        scene.background = null;
      }
    },
    changeExposure() {
      let { exposure } = this;
      let { renderer } = this;
      renderer.toneMappingExposure = exposure;
    },
  },
};
</script>